import { render, staticRenderFns } from "./CourierInfo.vue?vue&type=template&id=76b026b8&scoped=true&"
import script from "./CourierInfo.vue?vue&type=script&lang=js&"
export * from "./CourierInfo.vue?vue&type=script&lang=js&"
import style0 from "./CourierInfo.vue?vue&type=style&index=0&id=76b026b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b026b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VSelect,VTooltip})
